import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Kpi } from '../../../../model/kpi';
import { FormGroup } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { ActionButton } from '../../../../model/ui/action-button';
import { DeviceMeasurement } from '../../../../model/device-measurement';
import { AssetMeasurement } from '../../../../model/asset-measurement';

@Component({
  selector: 'app-synoptics-form-state-data',
  templateUrl: './synoptics-form-state-data.component.html',
  styleUrls: ['./synoptics-form-state-data.component.scss']
})
export class SynopticsFormStateDataComponent implements OnInit {

  @Input() synopticInfoForm: FormGroup;
  @Output() deviceMeasurementsChange: EventEmitter<DeviceMeasurement[]>;
  @Output() assetMeasurementsChange: EventEmitter<AssetMeasurement[]>;
  @Output() kpisChange: EventEmitter<Kpi[]>;

  public currentDeviceMeasurements: DeviceMeasurement[];
  public currentAssetMeasurements: AssetMeasurement[];
  public currentKpis: Kpi[];

  public measurementTabs: MenuItem[];
  public measurementTabsActive: MenuItem;

  public deviceMeasurementsFirst: number;
  public deviceMeasurementsRows: number;
  public displayDeviceMeasurementSelector: boolean;

  public assetMeasurementsFirst: number;
  public assetMeasurementsRows: number;
  public displayAssetMeasurementSelector: boolean;

  public kpisFirst: number;
  public kpisRows: number;
  public displayKpisSelector: boolean;
  public selectKpisActions: ActionButton[];

  constructor() {
    this.currentDeviceMeasurements = [];
    this.currentAssetMeasurements = [];
    this.currentKpis = [];
    this.displayDeviceMeasurementSelector = false;
    this.displayAssetMeasurementSelector = false;
    this.displayKpisSelector = false;
    this.deviceMeasurementsFirst = 0;
    this.deviceMeasurementsRows = 10;
    this.assetMeasurementsFirst = 0;
    this.assetMeasurementsRows = 10;
    this.kpisFirst = 0;
    this.kpisRows = 10;
    this.deviceMeasurementsChange = new EventEmitter<DeviceMeasurement[]>();
    this.assetMeasurementsChange = new EventEmitter<AssetMeasurement[]>();
    this.kpisChange = new EventEmitter<Kpi[]>();
    this.measurementTabs = [
      { id: 'deviceMeasurements', label: 'model.deviceMeasurements', icon: 'pi pi-fw pi-mobile' },
      { id: 'assetMeasurements', label: 'model.assetMeasurements', icon: 'pi pi-fw pi-map-marker' },
      { id: 'kpis', label: 'model.kpis', icon: 'pi pi-fw pi-chart-line' }
    ];
    this.measurementTabsActive = this.measurementTabs[0];
    this.selectKpisActions = [
      { label: 'select.kpis', icon: 'pi pi-check', action: (kpis: Kpi[]) => this.selectKpis(kpis) }
    ];
  }

  @Input()
  set deviceMeasurements(deviceMeasurements: DeviceMeasurement[]) {
    this.currentDeviceMeasurements = deviceMeasurements ? [...deviceMeasurements] : [];
  }

  @Input()
  set assetMeasurements(assetMeasurements: AssetMeasurement[]) {
    this.currentAssetMeasurements = assetMeasurements ? [...assetMeasurements] : [];
  }

  @Input()
  set kpis(kpis: Kpi[]) {
    this.currentKpis = kpis ? [...kpis] : [];
  }

  ngOnInit(): void {}

  private selectKpis(kpis: Kpi[]): void {
    this.displayKpisSelector = false;
    this.currentKpis = kpis;
    this.kpisChange.emit([...this.currentKpis]);
  }

  public removeDeviceMeasurement(measurement: DeviceMeasurement): void {
    const index = this.currentDeviceMeasurements.indexOf(measurement);
    this.currentDeviceMeasurements.splice(index, 1);
    this.deviceMeasurementsChange.emit([...this.currentDeviceMeasurements]);
  }

  public removeAssetMeasurement(measurement: AssetMeasurement): void {
    const index = this.currentAssetMeasurements.indexOf(measurement);
    this.currentAssetMeasurements.splice(index, 1);
    this.assetMeasurementsChange.emit([...this.currentAssetMeasurements]);
  }

  public removeKpi(kpi: Kpi): void {
    const index = this.currentKpis.indexOf(kpi);
    this.currentKpis.splice(index, 1);
    this.kpisChange.emit([...this.currentKpis]);
  }

}
